import type { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next'
import { Author } from '../../app/components/Author'
import { Footer } from '../../app/components/Footer'
import { Nav } from '../../app/components/Nav'
import { PageInfo } from '../../app/components/PageInfo'
import { scalarResolver } from '../../app/data/createScalarResolvers'
import { PlantProfileFragment } from '../../app/data/fragments/PlantProfileFragment'
import { UserFragment } from '../../app/data/fragments/UserFragment'
import { adminZeus } from '../../app/data/thunder'
import { PlantProfileState } from '../../generated/content'
import { serverPropsHandler } from '../../libs/next/api/handlers'

export default function AuthorPage(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
	return (
		<div>
			<PageInfo title={props.data.getUser?.nick || props.data.getUser?.email || ''} />
			<Nav />
			{props.data.getUser && (
				<Author author={props.data.getUser} plantProfiles={props.data.listPlantProfile} />
			)}
			<Footer />
		</div>
	)
}

export const getServerSideProps = serverPropsHandler(async (context: GetServerSidePropsContext) => {
	const authorId = String(context.params?.author) ?? null
	const locale = context.locale as string
	const data = await adminZeus('query', { scalars: scalarResolver })({
		listPageLocale: [{}, { title: true }],
		getUser: [{ by: { id: authorId } }, UserFragment()],
		listPlantProfile: [
			{
				filter: {
					author: { id: { eq: authorId } },
					activeRevision: { images: { items: { not: null } } },
					state: {
						eq: PlantProfileState.published,
					},
				},
			},
			PlantProfileFragment(locale),
		],
	})

	return { props: { data } }
})
